<template>
    <div style="overflow-x: hidden;background-color: white;">

       <!-- 顶部横幅区域 -->
       <div class="banner1">
        <van-icon class="banner1-back" name="arrow-left" size="30px" @click="goBack" />  
        <!-- logo 容器
             使用绝对定位将 logo 放置在横幅底部中间位置 -->
        <div class="banner1-img">
            <!-- logo 图片 -->
            <img src="@/assets/logocssss.png" alt="">
        </div>
    </div>
    
    <!-- 主体内容区域 -->
    <div class="bodyconten">
        <!-- 内容容器 -->
        <div class="bodyconten-content">
            <!-- 标题区域 -->
            <div class="bodyconten-content-title">
                <!-- 联系客服标题 -->
                <p>商业合作</p>
            </div>

            <div class="bodyconten-content-form1">
              <!-- 联系方式表单 -->
              <div class="bodyconten-content-form1-content">

                <!-- 联系我们标题 -->
                <div class="bodyconten-content-form1-content-title">联系我们</div>

                <!-- 联系方式内容 -->
                <div class="bodyconten-content-form1-content-content">

                   <!-- 邮箱联系方式项 -->
                   <div class="bodyconten-content-form1-content-content-item">
                    <!-- 邮箱图标 -->
                    <img src="@/assets/icon3-26.png" alt="">
                    <!-- 邮箱地址 -->
                    <p>邮箱：coop@puki.vip</p>
                   </div>
                   <!-- 邮箱联系方式项 -->
                   <div class="bodyconten-content-form1-content-content-item">
                    <!-- 邮箱图标 -->
                    <img src="@/assets/icon2-26.png" alt="">
                    <!-- 邮箱地址 -->
                    <p>+86/20/39390239</p>
                   </div>
                   <!-- 邮箱联系方式项 -->
                   <div class="bodyconten-content-form1-content-content-item">
                    <!-- 邮箱图标 -->
                    <img src="@/assets/cion1-26.png" alt="">
                    <!-- 邮箱地址 -->
                    <p>广州市南沙自贸区海滨路169号1楼122室</p>
                   </div>

                </div>

              </div>
            </div>


            <div class="bodyconten-content-form2">
                <div class="bodyconten-content-form2-content">
                        <!-- 联系我们标题 -->
                <div class="bodyconten-content-form2-content-title">商业合作留言</div>

                <form class="contact-form"  @submit.prevent="handleSubmit">
                    <div class="form-item">
                        <label for="name">姓名 <span style="color: #FF4D4F;">*</span></label>
                        <input type="text" id="name" v-model="formData.name" placeholder="请输入您的姓名" required>
                    </div>
                    <div class="form-item">
                        <label for="phone">公司名称 <span style="color: #FF4D4F;">*</span></label>
                        <input type="text" id="company" v-model="formData.company" placeholder="请输入您的公司名称" required>
                    </div>
                    <div class="form-item">
                        <label for="phone">联系电话 <span style="color: #FF4D4F;">*</span></label>
                        <input type="text" id="phone" v-model="formData.phone" placeholder="请输入您的联系电话" required>
                    </div>
                    <div class="form-item">
                        <label for="phone">电子邮箱 <span style="color: #FF4D4F;">*</span></label>
                        <input type="text"  id="email" v-model="formData.email" placeholder="请输入您的电子邮箱" required>
                    </div>
                    <div class="form-item">
                        <label for="phone">联系地址 <span style="color: #FF4D4F;">*</span></label>
                        <input type="text"  id="address" v-model="formData.address" placeholder="请输入您的联系地址" required>
                    </div>
                    <div class="form-item">
                        <label style="top: 35%;" for="phone">留言内容 <span style="color: #FF4D4F;">*</span></label>
                        <input style="height: 70px;" type="text" id="message" v-model="formData.message" placeholder="请输入您的留言内容" required>
                    </div>
                    
                    
                    <button type="submit" class="submit-button" style="background-color: #000; color: #fff;">点击提交</button>
                </form>
                
                </div>
            </div>

        </div>
        
    </div>
    <div>
      <bottomcontent></bottomcontent>
    </div>
        <div style="width: 100vw;">
          <bottomh5></bottomh5>
        </div>

    </div>
</template>
<script>
 import bottomh5 from'@/view/h5/public/bottomh5.vue'
  import bottomcontent from'@/view/h5/public/bottomcontent.vue'
 import axios from 'axios';
 import apiUrls from '@/http/http';
 import { Dialog, Toast } from "vant";
 export default {
    components:{
          bottomh5,
          bottomcontent
        },
        data() {
          return {
  
            formData: {
                name: '',
                    company: '',
                    phone: '',
                    email: '',
                    address: '',
                    message: ''
            },
            file: null,
            previewUrl: null,
            fileList:[]
            
              }
       },
       computed: {
        // 使用 computed 属性来拼接 URL
        uploadAction() {
            return `${apiUrls.baseUrl}/website/dev-api/common/upload`;
        },
    
    },
       methods:{
        goBack() {
      window.history.back(); // 让浏览器返回上一页
    },
        removeFile(index) {
        this.fileList.splice(index, 1);
        this.formData.fileimagelist.splice(index, 1);
    },
        // 点击上传按钮触发文件选择
        handleUploadClick() {
            this.$refs.uploadInput.click();
        },
         // 文件选择变更处理
         handleFileChange(event) {
            event.preventDefault();
            const file = event.target.files[0];
            if (file) {
                this.file = file;
                // 创建本地预览
                const reader = new FileReader();
                reader.onload = e => {
                    this.previewUrl = e.target.result;
                };
                reader.readAsDataURL(file);
                
                // 自动上传文件
                this.uploadFile(file);
            }
        },
         // 文件上传方法
         uploadFile(file) {
            if (!file) return;
            
            this.uploadLoading = true;
            const formData = new FormData();
            formData.append('file', file);
            
            // 使用计算属性中的上传URL
            axios.post(this.uploadAction, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
            //   console.log('上传成功:', response);
                this.handleSuccess(response.data, file);
            })
            .catch(error => {
                console.error('上传失败:', error);
                alert('图片上传失败，请重试');
            })
            .finally(() => {
                this.uploadLoading = false;
            });
        },
          // 上传成功回调
          handleSuccess(response, file) {
            // console.log('上传成功:', response);
            if (response.code === 200) { // 假设服务器返回的成功码是 200 
                // 拼接图片 URL，确保路径正确
                const imageUrl = `${apiUrls.baseUrl}/website/images/` + response.filePath;
                
                // 将上传的图片信息添加到 fileList 中
                this.fileList.push({
                    name: file.name,
                    url: imageUrl
                });
                console.log(this.fileList)
            } else { 
                alert('图片上传失败: ' + (response.message || '未知错误'));
            } 
        },

        async handleSubmit(event) {
            event.preventDefault(); 

          

            // **表单验证**
            if (!this.formData.name || !this.formData.phone || !this.formData.email || 
                !this.formData.address || !this.formData.message ) {
            alert("请填写所有必填字段，并至少上传一张图片！");
            return;
            }
                    // **手机号格式校验**
            const phoneRegex = /^1[3-9]\d{9}$/;
            if (!phoneRegex.test(this.formData.phone)) {
            alert("请输入有效的手机号！");
            return;
            }

                    // **邮箱格式校验**
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(this.formData.email)) {
            alert("请输入有效的邮箱地址！");
            return;
            }

            

           // **构造表单数据**
            const formData = new FormData();
            formData.append("name", this.formData.name);
            formData.append("phone", this.formData.phone);
            formData.append("email", this.formData.email);
            formData.append("address", this.formData.address);
            formData.append("message", this.formData.message);
         
            console.log(this.formData)

              axios.post(`${apiUrls.baseUrl}/website/addpartnersuer`, this.formData).then(response => {
                           
                            // 提示成功信息
                            Dialog.alert({
                            title: "提交成功",
                            message: response.data || "您的信息已提交成功！",
                            });

                            this.formData = {
                                name: '',
                                phone: '',
                                email: '',
                                address: '',
                                message: '',
                                imagess:''
                            };
                            this.fileList=[];

                             // 提交成功后清空表单
                            //   this.resetForm();

                        }).catch(error => {
                                            Dialog.alert({
                                title: "提交失败",
                                message: error.response?.data || "提交失败，请稍后再试",
                                });
                            
                        });   
                    },

       }
 }
</script>

<style scoped>
/deep/.el-menu{
    padding-left: 3.5vw;
  }
  .scroll-container {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch; /* 支持iOS惯性滚动 */
    scroll-behavior: smooth; /* 平滑滚动效果 */
    overflow-x: hidden;
  }
/* ===== 基础样式重置 ===== */
/* 移除浏览器默认样式，确保页面在各浏览器中有一致的基础样式 */
body {
    margin: 0; /* 移除浏览器默认的外边距 */
    padding: 0; /* 移除浏览器默认的内边距 */
    /* 不设置字体以继承浏览器默认字体，如需设置特定字体可在此添加 */
}

/* ===== 全局容器样式 ===== */
/* Vue 应用的根容器样式 - 整个应用的外层容器 */
.container {
    padding: 0; /* 移除内边距，确保内容紧贴边缘 */
    margin: 0; /* 移除外边距，确保容器紧贴浏览器边缘 */
   
    /* 注意：position:relative 使子元素的绝对定位以此元素为参考点 */
    /* 默认为 static 定位，不创建新的定位上下文 */
}

/* ===== 顶部横幅区域样式 ===== */
/* 页面顶部的图片背景区域，作为页面的视觉入口 */
.banner1 {
    /* 背景设置 - 层叠多种背景属性确保视觉效果 */
    background-color: green; /* 设置备用背景颜色，图片加载失败时显示 */
    background-image: url('@/assets/picbussinssbanner.png'); /* 设置横幅背景图片 */
   

     /* 关键属性，确保背景铺满但不变形 */
     background-size: cover; /* 让背景图片填充整个容器，可能裁剪部分 */
     background-position: center; /* 居中对齐，避免偏移 */
     background-repeat: no-repeat; /* 防止图片重复 */

    /* 尺寸设置 - 控制横幅的大小 */
    width: 100vw; /* 宽度设置为视口宽度，确保横幅占满屏幕宽度 */
    height: 145px; /* 设置固定高度，与设计稿保持一致 */
    
    /* 间距控制 - 确保没有多余空间 */
    margin: 0; /* 移除外边距，确保紧贴容器边缘 */
    padding: 0; /* 移除内边距，确保内容紧贴边缘 */

    /* 定位设置 - 为子元素提供定位上下文 */
    position: relative; /* 建立定位上下文，使 logo 可以相对横幅定位 */
    /* 不设置z-index，让堆叠顺序由DOM顺序决定 */
}
.banner1-back{
    position: absolute;
    font-size: 20px;
    top: 60px;
    left: 10px;
    color: white;
}
/* ===== Logo 容器样式 ===== */
/* 圆形白色logo容器，定位在横幅和内容区域之间，形成视觉焦点 */
.banner1-img {
    /* 定位设置 - 使logo位于视觉焦点位置 */
    position: absolute; /* 绝对定位，脱离文档流 */
    top: 80px; /* 从顶部向下偏移，使logo部分位于横幅下方 */
    left: 39vw; /* 从左侧偏移视口宽度的39%，实现水平居中效果 */
    
    /* Flexbox 布局 - 实现内部元素居中对齐 */
    display: flex; /* 启用弹性盒子布局 */
    flex-direction: column; /* 子元素垂直排列 */
    justify-content: center; /* 子元素在主轴（垂直方向）居中 */
    align-items: center; /* 子元素在交叉轴（水平方向）居中 */
    
    /* 外观样式 - 创建圆形白色容器 */
    background-color: white; /* 设置白色背景 */
    border-radius: 50%; /* 设置圆形边框（50%为完美圆形） */
    width: 80px; /* 设置容器宽度 */
    height: 80px; /* 设置容器高度，与宽度相等形成正圆 */
    
    /* 阴影和边框效果 - 增强视觉层次感 */
    box-shadow: 0 8px 8px rgba(207, 206, 206, 0.2); /* 添加柔和阴影：水平偏移0，垂直偏移8px，模糊8px */
    border: 2px solid #ccc; /* 添加2px宽的实线浅灰色边框 */
    
    /* 层级控制 - 确保logo不被其他元素遮挡 */
    z-index: 9999!important; /* 设置极高层级并使用!important确保优先级 */
}

/* Logo 图片样式 - 控制logo图片本身的尺寸和位置 */
.banner1-img img {
    width: 70px; /* 设置logo图片宽度，略小于容器保留边距 */
    height: auto; /* 高度自动计算，保持图片原始比例 */
    z-index: 999!important; /* 确保图片显示在较高层级 */
}

/* ===== 主体内容区域样式 ===== */
/* 页面主要内容的容器，包含所有信息展示和交互元素 */
.bodyconten {
    /* 外观样式 - 设置主体区域的视觉呈现 */
    border-radius: 20px 20px 0 0; /* 设置上方圆角：左上、右上20px */
    background-color: white; /* 设置白色背景 */
    
    /* 尺寸设置 - 控制主体区域大小 */
    height: 740px; /* 设置固定高度，确保足够的内容空间 */
    width: 100vw; /* 宽度设置为视口宽度，确保占满屏幕 */
    
    /* 位置控制 - 调整与上方元素的关系 */
    margin-top: 20px; /* 与上方横幅保持间距 */
    
    /* 定位和层级 - 建立层级关系 */
    position: relative; /* 建立定位上下文，为子元素提供定位参考 */
    z-index: 2; /* 设置层级高于横幅，但低于logo */
}

/* 主体内容内部容器 - 内容区域的内层容器 */
.bodyconten-content {
    /* 外观样式 - 继承主体区域的视觉特性 */
    border-radius: 20px 20px 0 0; /* 设置上方圆角，与父元素一致 */
    
    /* 位置调整 - 创建与横幅的重叠效果 */
    margin-top: -100px; /* 负边距使内容向上偏移，与横幅重叠 */
    
    /* 尺寸设置 */
    height: 300px; /* 设置固定高度 */
    width: 100vw; /* 宽度设置为视口宽度 */
    
    /* 背景设置 - 确保内容可见性 */
    background-color: transparent; /* 透明背景，显示下层元素 */
    /* 注意：这个负margin是实现内容区域与横幅重叠效果的关键 */
}

/* ===== 页面标题样式 ===== */
/* 主体内容顶部的标题区域 */
.bodyconten-content-title {
    /* 布局设置 - 使用Flexbox实现居中对齐 */
    display: flex; /* 启用弹性盒子布局 */
    justify-content: center; /* 水平居中对齐 */
    align-items: center; /* 垂直居中对齐 */
    
    /* 间距和尺寸 - 确保标题位置合适 */
    margin-top: 80px; /* 顶部外边距，为logo预留空间 */
    padding-top: 30px; /* 顶部内边距，增加视觉间距 */
    width: 100vw; /* 宽度设置为视口宽度 */
    
    /* 文字样式 */
    font-size: 15px; /* 设置字体大小，保持可读性 */
}

/* ===== 联系信息区域样式 ===== */
/* 包含联系方式的容器区域 */
.bodyconten-content-form1 {
    /* 尺寸设置 */
    width: 100vw; /* 宽度设置为视口宽度 */
    height: 200px; /* 设置固定高度，确保视觉一致性 */

    /* 布局设置 - 使用Flexbox实现居中对齐 */
    display: flex; /* 启用弹性盒子布局 */
    justify-content: center; /* 水平居中对齐 */
    align-items: center; /* 垂直居中对齐 */
}

/* 联系方式卡片样式 - 包含具体联系信息的容器 */
.bodyconten-content-form1-content{
    /* 尺寸和边距 */
    width: 82vw; /* 设置宽度为视口宽度的82%，两侧留有空间 */
    height: 200px; /* 设置固定高度，配合父容器 */
    
    /* 外观样式 - 创建卡片效果 */
    background-color: #F9F9F9; /* 设置浅灰色背景，与页面背景区分 */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 添加柔和阴影效果 */
    border-radius: 10px; /* 添加圆角，美化边角 */

    /* 布局设置 - 垂直排列内容并居中 */
    display: flex; /* 启用弹性盒子布局 */
    flex-direction: column; /* 子元素垂直排列 */
    justify-content: center; /* 子元素在垂直方向居中 */
    align-items: center; /* 子元素在水平方向居中 */
}

/* 联系方式卡片标题 - "联系我们"文字 */
.bodyconten-content-form1-content-title{
    /* 尺寸和边距 */
    width: 90%; /* 宽度设置为父容器的90%，留出两侧边距 */
    
    /* 文字样式 */
    font-size: 15px; /* 设置字体大小 */
    color: #676666; /* 设置深灰色文字颜色，增强可读性 */
    line-height: 50px; /* 设置行高，实现垂直居中效果 */
}

/* 联系方式列表容器 - 包含多个联系方式项 */
.bodyconten-content-form1-content-content{
    /* 尺寸和边距 */
    width: 90%; /* 宽度设置为父容器的90%，留出两侧边距 */
    height: 100%; /* 高度填满父容器 */
   
    /* 布局设置 - 垂直排列联系方式项并居中 */
    display: flex; /* 启用弹性盒子布局 */
    flex-direction: column; /* 子元素垂直排列 */
    justify-content: center; /* 子元素在垂直方向居中 */
    align-items: center; /* 子元素在水平方向居中 */
    
    /* 间距设置 */
    gap: 10px; /* 设置子元素之间的间距 */
    padding-bottom: 20px; /* 底部内边距，增加底部视觉空间 */
}

/* 单个联系方式项 - 如邮箱、电话等信息行 */
.bodyconten-content-form1-content-content-item{
    /* 尺寸设置 */
    width: 100%; /* 宽度填满父容器 */
    height: 30px; /* 设置固定高度，保持一致性 */
    
    /* 外观样式 */
    background-color: #ffffff; /* 设置白色背景，与卡片背景形成对比 */
    border-radius: 3px; /* 添加圆角，美化边角 */
    border: 2px solid #f8f6f6; /* 添加浅灰色边框，增强边界视觉 */

    /* 布局设置 - 水平排列图标和文字 */
    display: flex; /* 启用弹性盒子布局 */
    flex-direction: row; /* 子元素水平排列 */
    gap: 10px; /* 设置子元素之间的间距 */
}

/* 联系方式项图标 - 控制图标大小 */
.bodyconten-content-form1-content-content-item img{
    width: auto; /* 宽度自动调整，保持图片比例 */
    height: 30px; /* 高度与容器一致，填满行高 */
}

/* 联系方式项文本 - 显示具体联系信息 */
.bodyconten-content-form1-content-content-item p{
    /* 文本布局 */
    line-height: 30px; /* 行高与容器高度相同，实现垂直居中 */
    margin: 0; /* 移除段落默认边距 */
    
    /* 文字样式 */
    font-size: 14px; /* 设置字体大小，确保可读性 */
    color: #333; /* 设置深灰色文字颜色 */
    text-align: right; /* 文本向右对齐 */
}

/* ===== 表单区域样式 ===== */
/* 包含用户表单的容器区域 */
.bodyconten-content-form2{

    margin-top: 25px;
    /* 尺寸设置 */
    width: 100vw; /* 宽度设置为视口宽度 */
   
    /* 布局设置 - 使用Flexbox实现居中对齐 */
    display: flex; /* 启用弹性盒子布局 */
    justify-content: center; /* 水平居中对齐 */
    align-items: center; /* 垂直居中对齐 */
}

/* 表单卡片样式 - 包含表单元素的容器 */
.bodyconten-content-form2-content{
    /* 尺寸和边距 */
    width: 82%; /* 宽度设置为父容器的82%，两侧留有空间 */

    /* 外观样式 - 创建卡片效果 */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 添加柔和阴影效果 */
    border-radius: 10px; /* 添加圆角，美化边角 */
    background-color: #F9F9F9; /* 设置浅灰色背景，与页面背景区分 */
   
    /* 布局设置 - 垂直排列表单元素并居中 */
    display: flex; /* 启用弹性盒子布局 */
    flex-direction: column; /* 子元素垂直排列 */
    justify-content: center; /* 子元素在垂直方向居中 */
    align-items: center; /* 子元素在水平方向居中 */
    
    /* 间距设置 */
    gap: 10px; /* 设置子元素之间的间距 */
    padding-bottom: 20px; /* 底部内边距，增加底部视觉空间 */
}

/* 表单卡片标题 - "联系我们"文字 */
.bodyconten-content-form2-content-title{
    /* 尺寸和边距 */
    width: 90%; /* 宽度设置为父容器的90%，留出两侧边距 */
    
    /* 文字样式 */
    font-size: 15px; /* 设置字体大小 */
    color: #676666; /* 设置深灰色文字颜色，增强可读性 */
    line-height: 50px; /* 设置行高，实现垂直居中效果 */
}

/* 联系表单整体样式 - 表单元素的容器 */
.contact-form {
    /* 尺寸和布局 */
    width: 90%; /* 宽度设置为父容器的90%，留出两侧边距 */
    
    /* 布局设置 - 垂直排列表单项 */
    display: flex; /* 启用弹性盒子布局 */
    flex-direction: column; /* 子元素垂直排列 */
    gap: 1px; /* 设置表单项之间的间距 */
}

/* 表单项容器样式 - 每个输入项的容器 */
.form-item {
    /* 定位设置 - 为标签提供定位上下文 */
    position: relative; /* 相对定位，使label可以相对于它定位 */
    
    /* 尺寸和边距 */
    width: 100%; /* 宽度填满父容器 */
    margin-bottom: 10px; /* 底部外边距，增加表单项之间的间隔 */
   
}

/* 表单标签样式 - 输入框内的标签文本 */
.form-item label { 
    /* 文本样式 */
    font-size: 13px; /* 设置字体大小，较小以适应内部显示 */
    
    /* 定位设置 - 放置在输入框内部 */
    position: absolute; /* 绝对定位，脱离文档流 */
    width: 80px; /* 设置标签宽度，确保文本不会过长 */
    right: 70%; /* 从右侧向左偏移70%，放置在输入框左侧 */
    top: 20%; /* 从顶部向下偏移20%，实现垂直居中 */
    
    /* 交互控制 */
    pointer-events: none; /* 允许点击穿透标签到输入框 */
    z-index: 2; /* 确保显示在输入框之上 */
}

/* 必填项星号样式 - 表示必填的红色星号 */
.form-item label span {
    color: #FF4D4F; /* 设置红色，突出显示 */
    margin-left: 2px; /* 左侧外边距，与标签文本保持间距 */
}

/* 表单输入框通用样式 - 所有输入框的基础样式 */
.form-item input {
    /* 尺寸和边距 */
    width: 100%; /* 宽度填满父容器 */
    padding: 8px 90px; /* 内边距：上下8px，左右90px（为标签和右侧留出空间）*/
    height: 30px; /* 设置固定高度，确保视觉一致性 */
    
    /* 外观样式 */
    border: 2px solid #f8f6f6; /* 添加浅灰色边框 */
    border-radius: 3px; /* 添加圆角，美化边角 */
    background-color: #ffffff; /* 设置白色背景 */
    
    /* 文本样式 */
    font-size: 14px; /* 设置字体大小，确保可读性 */
    
    /* 盒模型控制 */
    box-sizing: border-box; /* 确保padding和border不会增加元素宽度 */
}

/* ===== 提交按钮样式 ===== */
/* 表单提交按钮 */
.submit-button {
    /* 尺寸和边距 */
    margin-top: 10px; /* 顶部外边距，与上方表单项保持间距 */
    padding: 10px; /* 内边距，增加按钮可点击区域 */
    height: 40px; /* 设置固定高度，确保视觉一致性 */
    width: 100%; /* 宽度填满父容器 */
    
    /* 外观样式 */
    border: none; /* 移除边框 */
    border-radius: 3px; /* 添加圆角，美化边角 */
    
    /* 文本样式 */
    font-size: 14px; /* 设置字体大小 */
    font-weight: bold; /* 设置粗体，增强视觉效果 */
    
    /* 交互控制 */
    cursor: pointer; /* 设置鼠标指针为手型，提示可点击 */
    /* 注意：背景颜色和文字颜色通过内联样式设置为黑底白字 */
}

/* 提交按钮悬停效果 - 鼠标移到按钮上的状态 */
.submit-button:hover {
    opacity: 0.9; /* 降低不透明度，提供视觉反馈 */
    /* 可以添加过渡效果使变化更平滑：transition: opacity 0.2s ease; */
}

.preview-container {
  display: flex;
  align-items: center;
  gap: 10px;

  position: absolute;
  left: 100px;
}

.preview-item {
  position: relative;
  width: 40px;
  height: 80px;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.delete-icon {
  position: absolute;
  top: -5px;
  right: -5px;
 
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  cursor: pointer;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

input::placeholder {
    white-space: nowrap; /* 防止换行 */
    overflow: visible; /* 让 placeholder 文字始终显示 */
    text-overflow: ellipsis; /* 如果空间不够，省略号显示 */
  }
  
</style>